import { DoorOpen, CircleDollarSign, Loader2 } from "lucide-react";
import { motion } from "framer-motion";
import { CurrencyField } from "@/components/ui/forms";

// Pantalla de apertura de turno (Caja Guard) — presentacional.
export const AbrirTurnoScreen = ({ fondo, setFondo, abrirTurno, opening }) => (
  <div className="flex-1 flex items-center justify-center px-6">
    <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.4 }}
      className="w-full max-w-md bg-white/5 border border-white/15 p-8" data-testid="caja-guard">
      <div className="h-14 w-14 bg-[#FFCC00]/10 border border-[#FFCC00]/40 flex items-center justify-center mx-auto mb-6"><DoorOpen className="h-7 w-7 text-[#FFCC00]" /></div>
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFCC00] text-center mb-2">Turno no iniciado</p>
      <h1 className="font-display text-3xl font-black tracking-tight text-center mb-2">Abrir Turno</h1>
      <p className="text-white/50 text-sm text-center mb-8">Ingresa el fondo inicial en caja para comenzar a operar.</p>
      <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-white/60">Fondo inicial en caja</label>
      <div className="relative mt-2 mb-6">
        <CircleDollarSign className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[#FFCC00]" />
        <CurrencyField inputMode="decimal" value={fondo} onChange={(v) => setFondo(v)}
          placeholder="0.00" data-testid="fondo-inicial-input"
          className="h-14 pl-11 rounded-none bg-white/5 border-white/20 text-white text-2xl font-display font-bold focus-visible:ring-2 focus-visible:ring-[#FFCC00]" />
      </div>
      <button onClick={abrirTurno} disabled={opening} data-testid="abrir-turno-btn"
        className="btn-hard w-full h-14 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] font-bold uppercase tracking-wider text-base flex items-center justify-center gap-2 disabled:opacity-60">
        {opening ? <Loader2 className="h-5 w-5 animate-spin" /> : <><DoorOpen className="h-5 w-5" /> Abrir turno</>}
      </button>
    </motion.div>
  </div>
);

export default AbrirTurnoScreen;
